<template>
  <div>
    <slot :openGallery="openGallery" />
    <slot
      v-for="(_, index) in galleryItems"
      name="image"
      :index="index"
      :openGallery="openGallery"
    />
  </div>
</template>

<script>
import Photoswipe, { getUrlParams } from './photoswipe';

export default {
  name: 'Photoswipe',

  props: {
    /**
     * @typedef {Object} PhotoswipeMedia
     * @property {String} src - large image URL
     * @property {String} msrc - placeholder image URL
     * @property {Number} w - image width
     * @property {Number} h - image height
     * @property {Boolean} isVideo - whether an item is an image or video
     * @property {String} [videoURL] - video URL, required only if isVideo is true
     *
     * @property {PhotoswipeMedia[]}
     */
    galleryItems: {
      type: Array,
      required: false,
      default: () => [],
    },

    options: {
      type: Object,
      required: false,
      default: () => ({
        closeOnScroll: false,
      }),
    },

    gid: {
      type: [Number, String],
      required: false,
      default: 1,
    },
  },

  data: () => ({
    photoswipe: null,
  }),

  watch: {
    images() {
      if (this.photoswipe) {
        this.photoswipe.destroy();
      }

      this.createPhotoswipeInstance();
    },
  },

  created() {
    if (!this.galleryItems.length) {
      return;
    }

    const { pid, gid } = getUrlParams();

    this.createPhotoswipeInstance(pid, gid);

    if (gid === this.gid && pid) {
      this.photoswipe.init();
    }
  },

  methods: {
    createPhotoswipeInstance(pid, gid) {
      this.photoswipe = Photoswipe({
        items: this.galleryItems,
        options: {
          ...this.options,
          galleryUID: gid || this.gid,
          index: pid - 1 || 0,
        },
      });
    },

    openGallery(imageIndex = 0) {
      this.createPhotoswipeInstance(imageIndex + 1);
      this.photoswipe.init();
    },
  },
};
</script>
